import { sectorLabel, sectorTone } from "components/missionDetail/sectors";

/**
 * A sector as a badge in its tone from the temp worker app (`sectorTone`): "Restauration" in
 * orange, "Logistique" in purple… `size="lg"` next to a big title (mission sheet), `size="sm"` in a
 * dense list line (job templates).
 */
const SectorBadge = ({ activity, size, className = "" }) => {
    if (!activity) return null;
    const tone = sectorTone(activity);

    return (
        <span
            className={`badge ${size === "lg" ? "badge-lg" : size === "sm" ? "badge-sm" : ""} ${className}`}
            style={{ backgroundColor: tone.bg, color: tone.fg }}
        >
            <span className="truncate">{sectorLabel(activity)}</span>
        </span>
    );
};

export default SectorBadge;
